import type { Catalog } from '..'

export const inspector: Catalog['inspector'] = {
  // frame inspector
  frameName: 'Nome do frame',
  lockedTitle: 'Bloqueado — não pode ser movido, redimensionado nem excluído no canvas',
  locked: 'Bloqueado',
  unlock: 'Desbloquear',
  groupDevelopment: 'Desenvolvimento',
  groupExport: 'Exportar',
  groupMemory: 'Memória',
  downloadPng: 'Baixar como PNG (2×)',
  downloadJpg: 'Baixar como JPG (2×)',
  copyPngTitle: 'Copiar a imagem (2×) para colar em qualquer lugar',
  copyPng: 'Copiar como PNG',
  copyImageUrlTitle:
    'URL pública da imagem — sempre mostra o design atual; cole como og:image ou imagem de destaque de um blog',
  copyImageUrl: 'Copiar URL da imagem',
  pinReferenceTitle: 'Adicionar à memória de design — será usado como referência',
  pinReference: 'Fixar como referência',
  hideHtmlEditor: 'Ocultar o editor de HTML',
  editHtml: 'Editar o HTML',
  code: 'Código',
  copyHtmlTitle: 'Copiar o HTML do frame',
  exportHtmlTitle: 'Salvar o HTML do frame como arquivo',
  export: 'Exportar',
  copyHtmlFailed: 'Não foi possível copiar o HTML. Selecione-o no editor e copie manualmente.',
  saveFailed: 'Não foi possível salvar o design. Tente novamente.',
  saving: 'salvando…',
  saved: 'salvo',
  lastEditBy: 'última edição por {name}',
  history: 'Histórico',
  unlockToDelete: 'Desbloqueie o frame para excluí-lo',
  xPosition: 'Posição X',
  yPosition: 'Posição Y',
  width: 'Largura',
  height: 'Altura',

  // element panel
  tabDesign: 'Design',
  tabHtml: 'HTML',
  tabPrototype: 'Protótipo',
  inParent: 'em {parent}',
  selectParent: 'Selecionar pai',
  readingElement: 'Lendo o elemento…',
  sectionAlignment: 'Alinhamento',
  sectionPosition: 'Posição',
  sectionLayout: 'Layout',
  sectionAppearance: 'Aparência',
  sectionFill: 'Preenchimento',
  sectionStroke: 'Borda',
  sectionText: 'Texto',
  rowType: 'Tipo',
  rowOrder: 'Ordem',
  rowMinWidth: 'Larg. mín.',
  rowDisplay: 'Exibição',
  rowGap: 'Espaçamento',
  rowOpacity: 'Opacidade',
  rowRadius: 'Raio',
  rowColor: 'Cor',
  rowWidth: 'Largura',
  rowFont: 'Fonte',
  rowSize: 'Tamanho',
  rowAlign: 'Alinhar',
  layerAlignment: 'Alinhamento da camada dentro do pai',
  alignLayerLeft: 'Alinhar camada à esquerda',
  centerLayerHorizontally: 'Centralizar camada na horizontal',
  alignLayerRight: 'Alinhar camada à direita',
  alignLayerTop: 'Alinhar camada ao topo',
  centerLayerVertically: 'Centralizar camada na vertical',
  alignLayerBottom: 'Alinhar camada à base',
  withinParent: '{label} dentro do pai',
  positionTitle: 'Posição renderizada em relação ao pai, em pixels do frame',
  rotation: 'Rotação',
  flipHorizontally: 'Espelhar na horizontal',
  flipVertically: 'Espelhar na vertical',
  positionType: 'Tipo de posição',
  orderOf: 'de {count}',
  unlinkSize: 'Desvincular largura e altura',
  linkSize: 'Vincular largura e altura',
  linkSizeDisabled: 'Defina largura e altura positivas para vinculá-las',
  widthSizing: 'Dimensionamento da largura',
  heightSizing: 'Dimensionamento da altura',
  sizeAuto: 'Auto',
  sizeFixed: 'Fixo',
  sizeFill: 'Preencher',
  sizeHug: 'Ajustar',
  minimumWidth: 'Largura mínima',
  display: 'Exibição',
  rowGapLabel: 'Espaçamento entre linhas',
  columnGap: 'Espaçamento entre colunas',
  hideElement: 'Ocultar elemento',
  showElement: 'Mostrar elemento',
  elementOpacity: 'Opacidade do elemento',
  cornerRadius: 'Raio dos cantos',
  clipContent: 'Recortar conteúdo',
  fillColor: 'Cor do preenchimento',
  fillOpacity: 'Opacidade do preenchimento',
  borderColor: 'Cor da borda',
  borderWidth: 'Largura da borda',
  sides: 'Lados: {sides}',
  sideTop: 'superior',
  sideRight: 'direito',
  sideBottom: 'inferior',
  sideLeft: 'esquerdo',
  fontFamily: 'Família da fonte',
  fontSize: 'Tamanho da fonte',
  fontWeight: 'Peso da fonte',
  textAlignment: 'Alinhamento do texto',
  alignLeft: 'Alinhar à esquerda',
  alignCenter: 'Centralizar',
  alignRight: 'Alinhar à direita',
  justify: 'Justificar',

  // padding and flex layout
  padding: 'Espaçamento interno',
  individualPadding: 'Espaçamento interno individual',
  individualPaddingTitle: 'Editar o espaçamento interno de cada lado',
  paddingTop: 'Espaçamento interno superior',
  paddingRight: 'Espaçamento interno direito',
  paddingBottom: 'Espaçamento interno inferior',
  paddingLeft: 'Espaçamento interno esquerdo',
  verticalPadding: 'Espaçamento interno vertical',
  horizontalPadding: 'Espaçamento interno horizontal',
  mixed: 'Misto',
  flexLayout: 'Layout flex',
  wrapChildren: 'Quebrar filhos em linhas',
  wrapReverse: 'Quebra em ordem inversa',
  flexDirection: 'Direção do flex',
  rowDirection: 'Direção em linha',
  columnDirection: 'Direção em coluna',
  reverseDirection: 'Inverter direção',
  alignment: 'Alinhamento',
  flexAlignment: 'Alinhamento do flex',
  alignChildren: 'Alinhar filhos {vertical} {horizontal}',
  alignKeep: '{label} (manter {spacing})',
  vTop: 'no topo',
  vMiddle: 'no meio',
  vBottom: 'na base',
  hLeft: 'à esquerda',
  hCenter: 'ao centro',
  hRight: 'à direita',
  crossAxisAlignment: 'Alinhamento no eixo cruzado',
  crossStart: 'Início',
  crossCenter: 'Centro',
  crossEnd: 'Fim',
  crossStretch: 'Esticar',
  crossBaseline: 'Linha de base',
  gap: 'Espaçamento',
  flexSpacing: 'Distribuição do flex',
  spacingFixed: 'Espaçamento fixo',
  spacingBetween: 'Espaço entre',
  spacingAround: 'Espaço ao redor',
  spacingEvenly: 'Espaço uniforme',
  lineGap: 'Espaço entre linhas',

  // image fill
  imageSizeFill: 'Preencher',
  imageSizeFit: 'Ajustar',
  imageSizeStretch: 'Esticar',
  imageSizeOriginal: 'Tamanho original',
  imageSizeScaleDown: 'Reduzir',
  imageSizeTile: 'Repetir',
  imageSizeCustom: 'Personalizado',
  imageUrlInvalid: 'Insira uma URL de imagem válida.',
  imageUrlProtocol: 'Use uma URL de imagem http ou https.',
  imageUrlTimeout: 'A imagem demorou demais para carregar. Tente outra URL.',
  imageUrlLoadFailed: 'Não foi possível carregar essa imagem. Verifique a URL e tente novamente.',
  imageTooLarge: 'Escolha uma imagem menor que 5 MB.',
  imageDesignChanged: 'O design mudou. Selecione a imagem e tente novamente.',
  imageNotEditable: 'A imagem não pode mais ser editada. Selecione-a e tente novamente.',
  imageReplaceFailed: 'Não foi possível substituir a imagem. Tente novamente.',
  chooseReplacementImage: 'Escolher imagem substituta',
  imageFill: 'Preenchimento de imagem',
  editImageFill: 'Editar preenchimento de imagem',
  image: 'Imagem',
  imageFillSettings: 'Configurações do preenchimento de imagem',
  closeImageSettings: 'Fechar configurações da imagem',
  imageUrl: 'URL da imagem',
  applyImageUrl: 'Aplicar URL da imagem',
  uploadImage: 'Enviar imagem',
  currentImage: 'Imagem atual',
  uploading: 'Enviando…',
  loading: 'Carregando…',
  sizing: 'Tamanho',
  imageSizing: 'Dimensionamento da imagem',

  // prototype interactions
  triggerClick: 'Ao clicar',
  triggerHover: 'Ao passar o mouse',
  triggerPress: 'Enquanto pressiona',
  triggerDelay: 'Após um tempo',
  triggerKey: 'Ao pressionar tecla',
  actionNavigate: 'Navegar para',
  actionOverlay: 'Abrir sobreposição',
  actionBack: 'Voltar',
  actionCloseOverlay: 'Fechar sobreposição',
  actionScrollTo: 'Rolar até',
  actionUrl: 'Abrir link',
  transitionInstant: 'Instantânea',
  transitionDissolve: 'Dissolver',
  transitionSlideLeft: 'Deslizar à esquerda',
  transitionSlideRight: 'Deslizar à direita',
  transitionSlideUp: 'Deslizar para cima',
  transitionSlideDown: 'Deslizar para baixo',
  transitionPushLeft: 'Empurrar à esquerda',
  transitionPushRight: 'Empurrar à direita',
  layerNotEditable: 'Esta camada não pode ser editada agora',
  interactions: 'Interações',
  addInteraction: 'Adicionar interação',
  scriptMade:
    'Um script cria este elemento, então ele não tem marcação para guardar interações. Adicione-as no HTML do frame.',
  unlockToAdd: 'Desbloqueie a camada para adicionar interações.',
  noInteractions: 'Nada acontece ainda quando isto é clicado.',
  flow: 'Fluxo',
  flowStartRow: 'Início',
  startsHere: 'Começa aqui',
  startFlowHere: 'Iniciar o fluxo neste frame',
  missingFrame: 'Frame ausente ({id})',
  interactionN: 'Interação {n}',
  rowTrigger: 'Gatilho',
  triggerN: 'Gatilho {n}',
  removeInteractionN: 'Remover interação {n}',
  rowAfter: 'Após',
  delayN: 'Atraso {n}',
  rowKey: 'Tecla',
  keyN: 'Tecla {n}',
  rowAction: 'Ação',
  actionN: 'Ação {n}',
  rowFrame: 'Frame',
  targetFrameN: 'Frame de destino {n}',
  addAnotherFrame: 'Adicione outro frame primeiro',
  rowElement: 'Elemento',
  scrollTargetN: 'Destino da rolagem {n}',
  rowUrl: 'URL',
  linkN: 'Link {n}',
  rowMotion: 'Movimento',
  transitionN: 'Transição {n}',
  durationN: 'Duração {n}',

  // element code view
  codeCopied: 'Código copiado',
  copyCode: 'Copiar código',
  codeCopiedStatus: 'Código copiado para a área de transferência',

  // property fields
  scrubHint: 'Arraste para ajustar · Shift: ×10 · Alt/Option: ×0,1 · Esc: cancelar',
  pickLabel: 'Escolher {label}',
  pickColour: 'Escolher cor',
  colorNone: 'nenhuma',
}
